var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenAnalyzer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wallet-money-icon",
    className: "wallet-money-icon",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 22.75h-17c-2.07 0-3.75-1.68-3.75-3.75v-17c0-.41.34-.75.75-.75s.75.34.75.75v17c0 1.24 1.01 2.25 2.25 2.25h17c.41 0 .75.34.75.75s-.34.75-.75.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.99982 17.7498c-.17 0-.35-.06-.49-.18-.31-.27-.35-.74-.08-1.06l4.59-5.36c.5-.58 1.21998-.93 1.97998-.96.76-.02 1.51.26 2.05.8l.95.95c.25.25.58.37.93.37.35-.01.67-.17.9-.44l4.59-5.35997c.27-.31.74-.35002 1.06-.08002.31.27.35.74.08 1.06l-4.59 5.35999c-.5.58-1.22.93-1.98.96-.76.02-1.51-.26-2.05-.8l-.94-.95c-.25-.25-.58-.38-.93-.37s-.67.17-.9.44l-4.58998 5.36c-.16.17-.37.26-.58.26z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenAnalyzer);
export default __webpack_public_path__ + "static/media/token-analyzer.45ce58fb97ccc5eef25faee1ca264b6f.svg";
export { ForwardRef as ReactComponent };